import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import { ImageBroken, CircleNotch } from '@phosphor-icons/react';

/**
 * Componente para mostrar imágenes desde endpoints protegidos con JWT.
 * Hace fetch con el token del interceptor y crea un blob URL.
 */
export function AuthImage({ fileId, alt, className, testId }) {
  const [src, setSrc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let objectUrl = null;
    let cancelled = false;

    const load = async () => {
      setLoading(true);
      setError(false);
      try {
        const res = await api.get(`/files/${fileId}`, { responseType: 'blob' });
        if (cancelled) return;
        objectUrl = URL.createObjectURL(res.data);
        setSrc(objectUrl);
      } catch (e) {
        if (!cancelled) setError(true);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    if (fileId) load();

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [fileId]);

  if (loading) {
    return (
      <div className={`${className} flex items-center justify-center bg-neutral-100`} data-testid={testId ? `${testId}-loading` : undefined}>
        <CircleNotch size={24} className="animate-spin text-neutral-400" />
      </div>
    );
  }

  if (error || !src) {
    return (
      <div className={`${className} flex flex-col items-center justify-center bg-neutral-100 text-neutral-400`} data-testid={testId ? `${testId}-error` : undefined}>
        <ImageBroken size={32} weight="bold" />
        <span className="text-[10px] uppercase tracking-widest mt-1">Sin imagen</span>
      </div>
    );
  }

  return <img src={src} alt={alt} className={className} data-testid={testId} />;
}
